import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import UploadMasterRegsCatalogModal from "./UploadMasterRegsCatalogModal";

interface IState {
	uploadModalVisible: boolean
}

export default class MasterRegsCatalog extends React.PureComponent<{}, IState> {

	constructor(props: {}) {
		super(props);
		this.state = {uploadModalVisible: false};
	}

	render() {
		return (
			<div>
				<PageHeaderView header={"Master Regs Catalog"}>
					<ButtonPrimary onClick={this.openUploadModal}
								   label={"Upload Master Catalog Regs"}
								   variant={"burgundy"}/>
				</PageHeaderView>
				{this.state.uploadModalVisible &&
				<UploadMasterRegsCatalogModal onClose={this.closeUploadModal}/>}
			</div>
		)
	}

	openUploadModal = () => this.setState({uploadModalVisible: true});

	closeUploadModal = () => this.setState({uploadModalVisible: false})
}
